export default {
  subheadline: 'Einrichten Ihrer Benutzer-Abonnements',
};
